/** Light green used on patient-v2 cards and badges (replaces theme secondary #7ABB9C). */
export const patientV2SoftBadgeClass =
  "border-transparent bg-[#DCF8C6] text-black text-xs";

export const patientV2InvalidBadgeClass =
"border-transparent bg-[#FEE2E2] text-[#991B1B] text-xs";

export const patientV2GrayBadgeClass =
"border-transparent bg-[#E5E5E5] text-[#808080] text-xs";
/** Border + stacked list shell for expandable row cards. */
export const patientV2ExpandableCardListClass =
  "overflow-hidden rounded-lg border border-[#E5E7EB] bg-white divide-y divide-[#E5E7EB]";
export const patientV2ExpandableCardDividerClass = "border-[#E5E7EB]";

/** Soft bluish tag for duration and similar emphasis labels. */
export const patientV2BlueOutlineBadgeClass =
  "border-[#BFDBFE] bg-[#EFF6FF] text-[#1D4ED8] text-xs capitalize";

/** Shared typography for patient-v2 list/table cards (12px+). */
export const patientV2CardBadgeClass = "text-xs";
export const patientV2CardTitleClass = "text-sm font-medium leading-snug";
export const patientV2CardMetaClass = "text-muted-foreground space-y-1 text-sm";
export const patientV2CardFieldLabelClass = "text-sm text-muted-foreground";
export const patientV2CardFieldValueClass = "truncate text-sm font-medium";

/** Visible separator between combined device reading values on one line. */
export const patientV2ReadingValueSeparator = " | ";

export function joinPatientV2ReadingValues(
  ...parts: Array<string | undefined | null>
): string {
  const visible = parts
    .map((part) => String(part ?? "").trim())
    .filter((part) => part && part !== "-" && part !== "—");

  return visible.length ? visible.join(patientV2ReadingValueSeparator) : "—";
}

export function isPatientV2FacilityPatient(
  patient: { typeOfPatient?: string } | null | undefined,
): boolean {
  return String(patient?.typeOfPatient ?? "").trim().toLowerCase() === "facility";
}
